import { data, Outlet } from 'react-router'
import { useBreadcrumbLd, useOrigin } from '#app/seo/hooks.ts'
import { buildOrganizationLd } from '#app/seo/structured-data.ts'
import { prisma } from '#app/utils/db.server.ts'
import { type Route } from './+types/_layout.ts'
import { MarketingFooter } from './components/footer.tsx'
import { MarketingHeader } from './components/header.tsx'

export async function loader({}: Route.LoaderArgs) {
	// Get categories and cities for sidebar navigation
	const [categories, cities] = await Promise.all([
		prisma.category.findMany({
			where: {
				businesses: { some: { status: 'published' } },
			},
			select: {
				id: true,
				name: true,
				slug: true,
				_count: {
					select: {
						businesses: {
							where: {
								status: 'published',
							},
						},
					},
				},
			},
			orderBy: {
				name: 'asc',
			},
		}),
		prisma.city.findMany({
			where: {
				businesses: { some: { status: 'published' } },
			},
			select: {
				id: true,
				name: true,
				slug: true,
				_count: {
					select: {
						businesses: {
							where: {
								status: 'published',
							},
						},
					},
				},
			},
			orderBy: {
				name: 'asc',
			},
		}),
	])

	return data({ categories, cities })
}

export default function MarketingLayout() {
	const origin = useOrigin()
	const breadcrumbLd = useBreadcrumbLd()

	return (
		<>
			<script
				type="application/ld+json"
				dangerouslySetInnerHTML={{ __html: buildOrganizationLd({ origin }) }}
			/>
			{breadcrumbLd ? (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: breadcrumbLd }}
				/>
			) : null}
			<MarketingHeader />
			<div className="flex w-full flex-1">
				<main className="flex-1">
					<Outlet />
				</main>
			</div>
			<MarketingFooter />
		</>
	)
}
